'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var extractUsingExpressions = function extractUsingExpressions(extractors) {
  return function (data) {
    for (var idx = 0; idx < extractors.length; idx++) {
      var result = extractors[idx](data);
      if (result) {
        return result;
      }
    }
  };
};

var extractErrorCode = extractUsingExpressions([function (data) {
  return data.error && data.error.code;
}, function (data) {
  return data.status;
}]);

var extractErrorMessage = extractUsingExpressions([function (data) {
  return data.error && data.error.message;
}, function (data) {
  return data.error && data.error.why;
}, function (data) {
  return typeof data.data === 'string' ? data.data : '';
}]);

var extractErrorDetails = extractUsingExpressions([function (data) {
  return data.error && data.error.details;
}, function (data) {
  return data.error && data.error.reason;
}]);

var extractErrorFromData = function extractErrorFromData(data) {
  if (typeof data !== 'object') {
    return null;
  }

  var code = extractErrorCode(data);
  var message = extractErrorMessage(data);
  var details = extractErrorDetails(data);

  if (message || details) {
    return { code: code, message: message, details: details };
  }

  return null;
};

exports['default'] = extractErrorFromData;
module.exports = exports['default'];